export interface MotionEvent {
  artifactId: string;
  artifactRegistrationTime: string;
  detectionType: number;
  name: string;
  picture: string | null;
  serialNumber: string;
}

export interface MotionEventBarVisibility {
  person: boolean;
  vehicle: boolean;
  animal: boolean;
}

export enum MotionEnum {
  Person = "person",
  Vehicle = "vehicle",
  Animal = "animal",
}
